function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import { textsDefaul, TYPE_CHANGE_METADA } from '@/js/constants';
import { mapState } from 'vuex';
export default {
  name: 'QueryTableProfilingComponent',
  props: {
    projectListDict: {
      type: Object,
      required: true,
      default: function _default() {}
    },
    domainList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      MODAL_NEW_PROFILING: 'MODAL_NEW_PROFILING',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      record: {},
      table: {},
      isSubmitting: false,
      recordMetadata: {},
      dismissCountDown: 0,
      dismissSecs: 5,
      dangerMessage: '',
      projectList: [],
      pickDomain: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc'])), {}, {
    texts: function texts() {
      return {
        domain: this.traductor('tablas.organization'),
        project: this.traductor('tablas.project'),
        table: this.traductor('tablas.table')
      };
    },
    rules: function rules() {
      var _this = this;
      return {
        organization: [function (v) {
          return !!v || _this.translate('reglas.organization');
        }],
        project: [function (v) {
          return !!v || _this.translate('reglas.proyecto');
        }],
        dataset: [function (v) {
          return !!v || _this.translate('reglas.dataset');
        }],
        table: [function (v) {
          return !!v || _this.translate('reglas.tabla');
        }]
      };
    }
  }),
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    getId: function getId() {
      return "".concat(this.record.project_name, ":").concat(this.record.dataset_name, ".").concat(this.record.table_name);
    },
    onSubmit: function onSubmit(event) {
      var _this2 = this;
      // event.preventDefault()
      if (!this.$refs.form.validate()) {
        return;
      }
      var defaultParams = {
        allDomains: false,
        domain: this.pickDomain,
        approval_flow: true,
        query: "name: ".concat(this.getId(), " tag:{project_id}.tpl_tables.env=prod"),
        searchWithTags: true,
        pageSize: 10,
        email: window.userInfo.email,
        projects: this.projects,
        catalogs: this.catalogs
      };
      TablesService.queryTables(defaultParams).then(function (response) {
        if (response && response.code === 200) {
          self.queryResponse = response.data || {};
          tasks.combineTagsInRows(self.queryResponse);
          self.messageEmptyList = !response.data.tables.length ? textsDefaul.NOT_TABLES : null;
          var _iterator = _createForOfIteratorHelper(response.data.tables),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var table = _step.value;
              if (table.id === _this2.getId()) {
                _this2.recordMetadata = table;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else if (response && response.code === 400) {
          console.log(response.code, response.message);
        }
        // callback && callback(response)
      }).then(function () {
        if (Object.keys(_this2.recordMetadata).length) {
          _this2.openProfilingModal(_this2.recordMetadata);
        } else {
          _this2.dismissCountDown = _this2.dismissSecs;
          _this2.dangerMessage = "".concat(_this2.getId(), " does not exists or it is not in 'prod' enviroment yet.");
        }
      }).catch(function (e) {
        utils.printError(e);
        self.messageEmptyList = 'The request was interrupted, try again';
      });
    },
    openProfilingModal: function openProfilingModal(item) {
      var _this3 = this;
      var rowData = utils.cloneJSON(item);
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          _this3.table = response.data;
          _this3.table.item = rowData;
          _this3.$emit('submitNewItem', _this3.table);
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onCancel: function onCancel() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (event) {
        event.preventDefault();
      }
      this.$emit('closeNewItem', null);
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};